import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NotificationComponent } from "src/app/shared/components/modals/notification/notification.component";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private readonly dialog: MatDialog) {}

  public openNotificationDialog(message) {
    this.dialog.open(NotificationComponent, {
      width: "700px",
      data: { message: message, button: "OK" },
    });
  }

  public openNotificationDialogCustomeButton(message, buttonLabel) {
    this.dialog.open(NotificationComponent, {
      width: "700px",
      data: { message: message, button: "COSTOME", buttonMessage: buttonLabel },
    });
  }
}
